<template>
  <div class="container" v-if="finalizoCargaInicial">
    <div class="row">
      <div class="col">
        <div class="alert alert-danger" role="alert" v-if="cameras == null || cameras.length===0">
          <img src="../assets/loading.gif" style="width: 30px;height: 30px;" alt=""/>
          Cargando.. camara!!
        </div>
        <div class="alert alert-danger" role="alert" v-if="marker == null">
          Debes habilitar la ubicación para continuar!!
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12" v-if="msj!=null">
        <div class="alert alert-warning" role="alert">
          {{ msj }}
        </div>
      </div>

      <header class="bg-dark py-4">
        <div class="container px-lg-3 px-xl-2 px-xxl-2">
          <div class="row gx-5 align-items-center justify-content-center">
            <div class="col-lg-6 col-xl-5 col-xxl-5">
              <div class="my-1 text-center text-xl-start">
                <template v-if="photo == null">
                  <h1 class="display-5 fw-bolder text-white mb-2">Registrar evidencia</h1>
<!--                  <p class="lead fw-normal text-white-50 mb-4">Se requiere una foto del área fisica que se ha limpiado. -->
<!--                    <br/>Sólo permite el acceso a la camara, selecciona el tipo de evidencia y registra</p>-->
<!--                  <div class="bg-secondary bg-gradient text-white rounded-3 mb-3"-->
<!--                    v-if="marker!=null">-->
<!--                    <l-map ref="map1" v-model:zoom="zoom" :center="[marker.lat, marker.lng]"-->
<!--                          style="width:100%; height:200px;">-->
<!--                      <l-tile-layer-->
<!--                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"-->
<!--                          layer-type="base"-->
<!--                          name="OpenStreetMap"/>-->
<!--                      <l-marker :lat-lng="marker" :draggable=false></l-marker>-->
<!--                    </l-map>-->
<!--                  </div>-->

                  <div class="d-grid gap-3 d-sm-flex justify-content-sm-center justify-content-xl-start">
                    <select class="form-select form-select-sm" aria-label="camera-sel"
                        @change="setCamera" v-model="deviceId">
                      <option value="" v-if="cameras == null || cameras.length === 0">--NO HAY CAMARA--</option>
                      <option v-for="camera in cameras" :value="camera.deviceId" :key="camera">{{camera.label}}</option>
                    </select>
                    <input type="text" class="form-control" placeholder="Número de empleado"
                          v-if="!$localStorageService.isAuth()"
                          aria-label="Núm. empleado"
                          aria-describedby="ESpecifica el número de empleado"
                          v-model="numeroEmpleado"
                          @keydown.prevent.enter="takePhoto"
                    >
                    <select class="form-select form-select-sm" aria-label="evidencia"
                            v-model="area"
                            v-if="$localStorageService.isAuth()"
                            :disabled="opciones == null || opciones.length < 2"
                            @change="takePhoto">
                      <option :value="null" selected>Seleccionar</option>
                      <template v-for="item in opciones" v-bind:key="item.id">
                        <option :value="item.id">{{ item.nombre }}</option>
                      </template>
                    </select>
                    <button type="button" class="btn btn-primary btn-lg px-4 me-sm-3"
                            @click="takePhoto"
                            :disabled="($localStorageService.isAuth() && area == null) || numeroEmpleado == null || cameras == null || cameras.length===0 || marker == null">
                      <img v-if="cameras == null || cameras.length===0 || marker == null" src="../assets/loading.gif"
                          style="width: 15px;height: 15px;" alt=""/>
                      Registrar
                    </button>
                  </div>
                </template>
                <template v-else>
                  <h1 class="display-5 fw-bolder text-white mb-2">Tu registro fue exitoso</h1>
                  <p class="lead fw-normal text-white-50 mb-4">Gracias por realizar tu registro</p>
                </template>
              </div>
            </div>
            <div class="col-xl-6 col-xxl-4 d-xl-block text-center">
              <div class="img-fluid rounded-3 my-0">
                <template v-if="photo == null && permisoCamara">
                  <WebCam :fullscreenState="false" ref="webcam"
                            @photoTaken="photoTakenEvent" @init="webcamInit"
                            :fullscreenButton="{
                              type: Object,
                              default: {
                                  display: false,
                                  text: 'Fullscreen',
                                  css: 'inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-500 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                              }
                            }"
                            :takePhotoButton="{
                            type: Object,
                            default: {
                                display: false,
                                text: 'Take a photo',
                                css: 'inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-indigo-500 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                                }
                            }"/>
                  <button @click="takePhoto" v-if="false">Take a photo</button>
                </template>
                <div class="row" v-if="photo != null">
                  <div class="col-12 ">
                    <img style='display:block; width:100%;height:100%;'
                         :src="photo.image_data_url" alt=""/>
                  </div>
                  <div class="col-12" v-if="marker!=null">
                    <l-map ref="map" v-model:zoom="zoom" :center="[marker.lat, marker.lng]"
                           style="width:100%; height:200px;">
                      <l-tile-layer
                          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                          layer-type="base"
                          name="OpenStreetMap"/>
                      <l-marker :lat-lng="marker" :draggable=false></l-marker>
                    </l-map>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div class="py-5 bg-light" v-if="photo != null">
        <div class="container px-lg-3 px-xl-2 px-xxl-2 my-5">
          <div class="row gx-5 justify-content-center">
            <div class="col-lg-10 col-xl-7">
              <div class="text-center">
                <div class="fs-4 mb-4 fst-italic">Registros del día</div>
                <div class="d-flex align-items-center justify-content-center">
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col">Área</th>
                      <th scope="col">Fecha</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in registrosDelDia" v-bind:key="item.id">
                      <th scope="row">{{ item.area__sucursal__nombre }}</th>
                      <td>{{ moment(item.fecha).format('DD/MM/YYYY h:mm:ss a') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import {LMap, LTileLayer, LMarker} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css"
import {WebCam} from "vue-camera-lib";
import {faHouse, faUser} from "@fortawesome/free-solid-svg-icons";
import {
  isAndroid,
  isChrome,
  isChromium,
  isConsole,
  isDesktop,
  isEdge,
  isEdgeChromium,
  isEdgeLegacy,
  isElectron,
  isEmbedded,
  isFirefox,
  isIE,
  isIOS,
  isIPad,
  isIPhone,
  isIPod,
  isLinux,
  isMacOS,
  isMIUI,
  isMobile,
  isMobileOnly,
  isMobileSafari,
  isOpera,
  isSafari,
  isSamsungBrowser,
  isSmartTV,
  isTablet,
  isWearable,
  isWindows,
  isWinPhone,
  isYandex,
  browserName,
  browserVersion,
  deviceModel,
  deviceType,
  deviceVendor,
  engineName,
  engineVersion,
  getUA,
  osName,
  osVersion
} from '@basitcodeenv/vue3-device-detect';
import moment from 'moment'
import {inject} from "vue";
import {EvidenciaService} from "@/services/EvidenciaService";
import {ExtService} from "@/services/ExtService";
import {EventosService} from "@/services/EventosService";

export default {
  name: 'Evidencia-Component',
  inject: ['$axios', '$localStorageService'],
  components: {
    LMap,
    LTileLayer,
    LMarker,
    WebCam
  },
  setup() {
    return {
      srv_extService: new ExtService( inject('$axios')),
      srv_eventosService: new EventosService(inject('$axios')),
      srv_evidenciaService: new EvidenciaService( inject('$axios'))
    }
  },
  data() {
    return {
      permisoCamara: false,
      marker: null,
      zoom: 13,
      msj: null,
      cameras: [],
      deviceId: '',
      photo: null,
      registrosDelDia: null,
      numeroEmpleado: null,
      area: null,
      deviceInfo: [],
      opciones: [],
      finalizoCargaInicial: false
    }
  },
  async created() {
    this.moment = moment;
    this.finalizoCargaInicial = false;

    if(this.titulo == null){
      this.evento = "evidencias"
    }else{
      this.evento = this.titulo
    }
  },

  async mounted() {

    this.numeroEmpleado = null;
    if (this.$localStorageService.isAuth()) {
      this.numeroEmpleado = this.$localStorageService.getNumEmpleado();
    }

    this.llenarDatosNavegador();
    await this.obtenerOptAreasEmpleados();
    this.getPosition();

    try {
      await this.srv_extService.obtenerIP().then(response => {
        this.deviceInfo.push({tag: "IP", valor: response.data.ip});
      });
    } catch (e) {
      console.error(e);
    }

    this.finalizoCargaInicial = true;

    this.permisoCamara = false;
    await navigator.mediaDevices.getUserMedia({
      video: true,
      // deviceId: { exact: 2 },
      frameRate: {ideal: 30},
      height: {ideal: 2160},
      width: {ideal: 4096}
    }).then(async () => {
      console.info("---------------camara permitida si");
      this.permisoCamara = true;
      await this.initTodo(true);
    }).catch(errorStream => {
      console.info("---------------camara permitida no");
      console.info(errorStream);
    });

  },
  methods: {

    llenarDatosNavegador() {
      if (isAndroid) {
        this.deviceInfo.push({tag: "isAndroid", valor: isAndroid});
      }
      if (isChrome) {
        this.deviceInfo.push({tag: "isChrome", valor: isChrome});
      }
      if (isChromium) {
        this.deviceInfo.push({tag: "isChromium", valor: isChromium});
      }
      if (isConsole) {
        this.deviceInfo.push({tag: "isConsole", valor: isConsole});
      }
      if (isDesktop) {
        this.deviceInfo.push({tag: "isDesktop", valor: isDesktop});
      }
      if (isEdge) {
        this.deviceInfo.push({tag: "isEdge", valor: isEdge});
      }
      if (isEdgeChromium) {
        this.deviceInfo.push({tag: "isEdgeChromium", valor: isEdgeChromium});
      }
      if (isEdgeLegacy) {
        this.deviceInfo.push({tag: "isEdgeLegacy", valor: isEdgeLegacy});
      }
      if (isElectron) {
        this.deviceInfo.push({tag: "isElectron", valor: isElectron});
      }
      if (isEmbedded) {
        this.deviceInfo.push({tag: "isEmbedded", valor: isEmbedded});
      }
      if (isFirefox) {
        this.deviceInfo.push({tag: "isFirefox", valor: isFirefox});
      }
      if (isIE) {
        this.deviceInfo.push({tag: "isIE", valor: isIE});
      }
      if (isIOS) {
        this.deviceInfo.push({tag: "isIOS", valor: isIOS});
      }
      if (isIPad) {
        this.deviceInfo.push({tag: "isIPad", valor: isIPad});
      }
      if (isIPhone) {
        this.deviceInfo.push({tag: "isIPhone", valor: isIPhone});
      }
      if (isIPod) {
        this.deviceInfo.push({tag: "isIPod", valor: isIPod});
      }
      if (isLinux) {
        this.deviceInfo.push({tag: "isLinux", valor: isLinux});
      }
      if (isMIUI) {
        this.deviceInfo.push({tag: "isMIUI", valor: isMIUI});
      }
      if (isMacOS) {
        this.deviceInfo.push({tag: "isMacOS", valor: isMacOS});
      }
      if (isMobile) {
        this.deviceInfo.push({tag: "isMobile", valor: isMobile});
      }
      if (isMobileOnly) {
        this.deviceInfo.push({tag: "isMobileOnly", valor: isMobileOnly});
      }
      if (isMobileSafari) {
        this.deviceInfo.push({tag: "isMobileSafari", valor: isMobileSafari});
      }
      if (isOpera) {
        this.deviceInfo.push({tag: "isOpera", valor: isOpera});
      }
      if (isSafari) {
        this.deviceInfo.push({tag: "isSafari", valor: isSafari});
      }
      if (isSamsungBrowser) {
        this.deviceInfo.push({tag: "isSamsungBrowser", valor: isSamsungBrowser});
      }
      if (isSmartTV) {
        this.deviceInfo.push({tag: "isSmartTV", valor: isSmartTV});
      }
      if (isTablet) {
        this.deviceInfo.push({tag: "isTablet", valor: isTablet});
      }
      if (isWearable) {
        this.deviceInfo.push({tag: "isWearable", valor: isWearable});
      }
      if (isWindows) {
        this.deviceInfo.push({tag: "isWindows", valor: isWindows});
      }
      if (isWinPhone) {
        this.deviceInfo.push({tag: "isWinPhone", valor: isWinPhone});
      }
      if (isYandex) {
        this.deviceInfo.push({tag: "isYandex", valor: isYandex});
      }
      if (browserName() != null && browserName() != "") {
        this.deviceInfo.push({tag: "browserName", valor: browserName()});
      }
      if (browserVersion() != null && browserVersion() != "") {
        this.deviceInfo.push({tag: "browserVersion", valor: browserVersion()});
      }
      if (deviceModel() != null && deviceModel() != "") {
        this.deviceInfo.push({tag: "deviceModel", valor: deviceModel()});
      }
      if (deviceType() != null && deviceType() != "") {
        this.deviceInfo.push({tag: "deviceType", valor: deviceType()});
      }
      if (deviceVendor() != null && deviceVendor() != "") {
        this.deviceInfo.push({tag: "deviceVendor", valor: deviceVendor()});
      }
      if (engineName() != null && engineName() != "") {
        this.deviceInfo.push({tag: "engineName", valor: engineName()});
      }
      if (engineVersion() != null && engineVersion() != "") {
        this.deviceInfo.push({tag: "engineVersion", valor: engineVersion()});
      }
      if (getUA() != null && getUA() != "") {
        this.deviceInfo.push({tag: "getUA", valor: getUA()});
      }
      if (osName() != null && osName() != "") {
        this.deviceInfo.push({tag: "osName", valor: osName()});
      }
      if (osVersion() != null && osVersion() != "") {
        this.deviceInfo.push({tag: "osVersion", valor: osVersion()});
      }
    },

    faUser() {
      return faUser
    },
    faHouse() {
      return faHouse
    },
    async obtenerOptAreasEmpleados() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: true,
        onCancel: this.onCancelLoader,
      });
      await this.srv_eventosService.obtenerOptAreasEmpleado(this.numeroEmpleado).then((response) => {
        this.opciones = response;

        if (this.opciones != null && this.opciones.length === 1) {
          this.area = this.opciones[0].id;
        }
      }).catch((error) => {
        this.$swal(error.message);
        console.error(error)
      }).finally(()=>load.hide());
    },
    async initTodo(initCamera) {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: true,
        onCancel: this.onCancelLoader,
      });

      this.registrosDelDia = null;

      await this.initCameras(initCamera);

      load.hide();
    },
    onCancelLoader() {
      console.log('User cancelled the loader.')
    },
    async initCameras(initCamera) {
      this.photo = null;
      this.registrosDelDia = null;
      if (initCamera) {
        const delay = ms => new Promise(res => setTimeout(res, ms));
        while(this.$refs.webcam == null) {
          await delay(1000);
        }

        await this.loadCameras();
        if (this.cameras.length === 0) {
          // if no camera found, we will try to refresh cameras list each second until there is some camera
          let reloadCamInterval = setInterval(() => {
            this.loadCameras()
            if (this.cameras.length > 0) {
              clearInterval(reloadCamInterval)
            }
          }, 1000);
        }
      }
    },
    async takePhoto() {
      if (this.area == null){
        return
      }
      try {
        if (this.$refs.webcam != null) {
          await this.$refs.webcam.takePhoto();
        }
      } catch (err) {
        console.log(err)
      }
    },
    async loadCameras() {
      if (this.$refs.webcam != null) {
        await this.$refs.webcam.loadCameras()
        this.cameras = this.$refs.webcam.cameras;
      }
    },
    async webcamInit(deviceId) {
      this.deviceId = deviceId
      this.$emit('init', this.deviceId)
    },
    async setCamera() {
      if (this.$refs.webcam != null) {
        this.$refs.webcam.changeCamera(this.deviceId === '' ? null : this.deviceId)
      } else {
        this.deviceId = '';
      }
    },
    async photoTakenEvent({blob, image_data_url}) {
      // this.$emit('photoTaken', { blob, image_data_url })
      // console.info(JSON.stringify(this.deviceInfo));
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
      });

      this.photo = null;
      this.registrosDelDia = null;

      let data = new FormData();
      let fileName = 'photo.jpg';
      let file = new File([blob], fileName);
      data.append('photo', file, fileName);
      data.append('numeroEmpleado', this.numeroEmpleado);
      data.append('area', this.area)
      data.append('metadata', JSON.stringify(this.deviceInfo));

      await this.srv_evidenciaService.registarEvidencia(data)
      .then(() => {
        this.photo = {
          blob: blob,
          image_data_url: image_data_url
        };
        // this.$swal({
        //   icon: 'info',
        //   text: response.data,
        //   showCloseButton: false,
        //   showCancelButton: false,
        //   focusConfirm: false,
        // })
      }).catch(error => {
        console.error(error)
        load.hide();
            this.$swal({
              icon: 'error',
              text: error.message,
              showCloseButton: false,
              showCancelButton: false,
              focusConfirm: false,
            })
      });

      if (this.photo != null) {
        await this.srv_evidenciaService.obtenerRegistrosEvidencias(this.numeroEmpleado)
            .then(response => {
              this.registrosDelDia = response;
              load.hide();

              window.scrollTo({ top: 0, behavior: 'smooth' });

              const initt = this;
              setTimeout(function () {
                // initt.initTodo(false);
                initt.$router.push({ name: 'perfil'}).then(() => {
                  initt.$router.go(0);
                });
              }, 2000);



            }).catch(error => {
              console.error(error)
              load.hide();
              this.$swal({
                icon: 'error',
                text: error.message,
                showCloseButton: false,
                showCancelButton: false,
                focusConfirm: false,
              })
            });
      }
    },
    getPosition() {
      this.marker = null;
      const geo_options = {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      };
      navigator.geolocation.watchPosition(this.actualizaPosicion, this.errorActualizaPosicion, geo_options)
    },
    errorActualizaPosicion(err) {
      console.error(err)
    },
    actualizaPosicion(position) {
      // console.log(position.coords.latitude);
      // console.log(position.coords.longitude);
      this.marker = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      this.deviceInfo.push({tag: "position", valor: this.marker})
    }
  },
};
</script>

<style scoped>

</style>
